var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app-bar',{attrs:{"app":"","clipped-left":"","fixed":""}},[_c('v-toolbar-title',[_vm._v("HWEducation")]),_c('v-app-bar-nav-icon',{staticClass:"hidden-md-and-up ms-auto me-4",attrs:{"aria-label":"MobileMenu"},on:{"click":function($event){return _vm.$emit('handleDrawer')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }